import { Component, Input, type OnInit, type OnDestroy, signal } from "@angular/core"
import { CommonModule } from "@angular/common"

@Component({
  selector: "app-payment-timer",
  standalone: true,
  imports: [CommonModule],
  templateUrl: "./payment-timer.component.html",
  styleUrls: ["./payment-timer.component.css"],
})
export class PaymentTimerComponent implements OnInit, OnDestroy {
  @Input() expiresAt!: string

  timeRemaining = signal<string>("")
  isExpired = signal<boolean>(false)
  isUrgent = signal<boolean>(false)
  private intervalId?: number

  ngOnInit() {
    this.updateTimer()
    this.intervalId = window.setInterval(() => {
      this.updateTimer()
    }, 1000)
  }

  ngOnDestroy() {
    if (this.intervalId) {
      clearInterval(this.intervalId)
    }
  }

  private updateTimer() {
    const now = new Date().getTime()
    const expiryTime = new Date(this.expiresAt).getTime()
    const difference = expiryTime - now

    if (difference <= 0) {
      this.timeRemaining.set("Expirado")
      this.isExpired.set(true)
      if (this.intervalId) {
        clearInterval(this.intervalId)
      }
      return
    }

    const days = Math.floor(difference / (1000 * 60 * 60 * 24))
    const hours = Math.floor((difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
    const minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60))
    const seconds = Math.floor((difference % (1000 * 60)) / 1000)

    this.isUrgent.set(difference < 6 * 60 * 60 * 1000)

    let timeString = ""
    if (days > 0) {
      timeString = `${days}d ${hours}h ${minutes}m ${seconds}s`
    } else if (hours > 0) {
      timeString = `${hours}h ${minutes}m ${seconds}s`
    } else if (minutes > 0) {
      timeString = `${minutes}m ${seconds}s`
    } else {
      timeString = `${seconds}s`
    }

    this.timeRemaining.set(timeString)
  }
}